// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import ObjectManagerScreenTemplate from '@front/templates/ObjectManagerScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { Control } from '../elements/Control';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { ThemeManager } from '../misc/ThemeManager';
export class ObjectManagerScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    setChartToScreen(chart) {
        this._indicatorsManagerPanel.Chart = chart;
        this._drawingsManagerPanel.Chart = chart;
        this._overlaysManagerPanel.Chart = chart;
    }
    getType() {
        return 'ObjectManagerScreen';
    }
    oninit() {
        super.oninit();
        this._indicatorsManagerPanel = super.findComponent('indicatorsManagerPanel');
        this._drawingsManagerPanel = super.findComponent('drawingsManagerPanel');
        this._overlaysManagerPanel = super.findComponent('overlaysManagerPanel');
    }
    oncomplete() {
        super.oncomplete();
        this.OnResize.Subscribe(this.layoutTable, this);
        Control.Ticker.Subscribe(this.TickAsync, this);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        ThemeManager.onThemeChange.Subscribe(this.themeChange, this);
        this.localize();
        this.layoutTable();
        this.center();
    }
    localize() {
        super.localize();
        void this.set({
            header: Resources.getResource('ChartObjectManager.Text')
        });
        this._indicatorsManagerPanel.localize();
        this._drawingsManagerPanel.localize();
        this._overlaysManagerPanel.localize();
    }
    layoutTable() {
        this._indicatorsManagerPanel.layoutTable();
        this._drawingsManagerPanel.layoutTable();
        this._overlaysManagerPanel.layoutTable();
    }
    TickAsync() {
        if (!this.get('visible')) {
            return;
        }
        this._indicatorsManagerPanel.TickAsync();
        this._drawingsManagerPanel.TickAsync();
        this._overlaysManagerPanel.TickAsync();
    }
    dispose() {
        this.OnResize.UnSubscribe(this.layoutTable, this);
        Control.Ticker.UnSubscribe(this.TickAsync, this);
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        ThemeManager.onThemeChange.UnSubscribe(this.themeChange, this);
        this._indicatorsManagerPanel.dispose();
        this._drawingsManagerPanel.dispose();
        this._overlaysManagerPanel.dispose();
        super.dispose();
    }
    repopulate() {
        this._indicatorsManagerPanel.repopulate();
        this._drawingsManagerPanel.repopulate();
        this._overlaysManagerPanel.repopulate();
    }
    themeChange() {
        this._indicatorsManagerPanel.applyTheme();
        this._drawingsManagerPanel.applyTheme();
        this._overlaysManagerPanel.applyTheme();
    }
}
TerceraWindowBase.extendWith(ObjectManagerScreen, {
    data: function () {
        return {
            movable: true,
            resizable: true,
            showFooter: false,
            focused: true,
            dockablePanel: false,
            showHeader: true,
            width: 700,
            height: 500,
            arrayHeaderTabs: [],
            style_addition_header: 'objectManagerScreen-AdditionalHeader',
            name: 'objectManagerScreen'
        };
    },
    partials: { bodyPartial: ObjectManagerScreenTemplate }
});
